import React from "react";
import { AppBar, Box, Button, Toolbar } from "@mui/material";
import { Link as RouterLink, Outlet } from "react-router-dom";
import { BrandLogo, ThemeToggle } from "../components";
import { ROUTES } from "../utils";

export const AppLayout: React.FC<{ showAppBar?: boolean }> = ({
  showAppBar = true,
}) => (
  <Box
    sx={{
      height: "100vh",
      display: "flex",
      flexDirection: "column",
      background: (theme) =>
        `linear-gradient(180deg, ${theme.palette.background.paper} 0%, ${theme.palette.background.default} 100%)`,
      position: "relative",
    }}
  >
    {showAppBar && (
      <AppBar position="sticky" color="default" elevation={0}>
        <Toolbar>
          <Box sx={{ flexGrow: 1, display: "flex", alignItems: "center" }}>
            <Box
              component={RouterLink}
              to={ROUTES.LOGIN}
              sx={{
                display: "inline-flex",
                alignItems: "center",
                textDecoration: "none",
                color: "inherit",
              }}
            >
              <BrandLogo />
            </Box>
          </Box>
          <Button
            component={RouterLink}
            to={ROUTES.FAQ}
            color="inherit"
            sx={{ mr: 1 }}
          >
            FAQ
          </Button>
          <ThemeToggle />
        </Toolbar>
      </AppBar>
    )}
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        display: "flex",
        justifyContent: "center",
        overflow: "hidden",
        p: { xs: 2, md: 4 },
        minHeight: 0,
      }}
    >
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "stretch",
          minHeight: 0,
        }}
      >
        <Outlet />
      </Box>
    </Box>
  </Box>
);
